jQuery(function($){

  if($('.jw_prd_custom_tab_wrapper').length >0){
     $('.jw-hmdi').each(function(){
        var $root=$(this), $body=$root.find('.jw-hmdi__body').first();
        var open=String($root.data('open'))==='true';
        $root.attr('aria-expanded', open);
        if(open){ $body.prop('hidden', false).show(); }
        else    { $body.prop('hidden', true).hide(); }
      });

       // Toggle with slide animation
    $(document).on('click', '.jw-hmdi__header', function(){
      var $root=$(this).closest('.jw-hmdi');
      var $body=$root.find('.jw-hmdi__body').first();
      var expanded=$root.attr('aria-expanded')==='true';
      if(expanded){
        $root.attr('aria-expanded','false');
        $body.stop(true,true).slideUp(220, function(){ $body.prop('hidden', true); });
      }else{
        $root.attr('aria-expanded','true');
        $body.prop('hidden', false).stop(true,true).slideDown(220);
      }
    });

    // Tabs
    $(document).on('click', '.jw-hmdi__tab', function(){
      var $btn=$(this), idx=$btn.data('idx'), $root=$btn.closest('.jw-hmdi');
      $root.find('.jw-hmdi__tab').removeClass('is-active');
      $btn.addClass('is-active');
      $root.find('.jw-hmdi__panel').removeClass('is-active')
           .filter('[data-idx="'+idx+'"]').addClass('is-active');
    });

  }
    // ===top bar mobile Config====
  const MOBILE_MAX = 768;      // px
  const HOLD_MS    = 6000;     // time each state is held
  const FADE_MS    = 1000;      // cross-fade duration

  let intervalId = null;
  let isMobileRunning = false; // track current mode to avoid unnecessary restarts
  let showTextState = false;   // false = show pair (0 & 2), true = show single (1)

  function crossFade($toShow, $toHide) {
    // Stop any ongoing animations and cross-fade simultaneously
    $toShow.stop(true, true).css('display', 'block').animate({opacity: 1}, FADE_MS);
    $toHide.stop(true, true).animate({opacity: 0}, FADE_MS, function() {
      $(this).css('display', 'none'); // remove from flow after fade
    });
  }

  function showPair() {
    crossFade($("#b_top-bar-0, #b_top-bar-2"), $("#b_top-bar-1"));
  }

  function showSingle() {
    crossFade($("#b_top-bar-1"), $("#b_top-bar-0, #b_top-bar-2"));
  }

  function startMobileSlider() {
    // Initial state (pair visible, single hidden) with no flash
    $("#b_top-bar-0, #b_top-bar-2").stop(true, true).css({display:'block', opacity:1});
    $("#b_top-bar-1").stop(true, true).css({display:'none',  opacity:0});

    showTextState = false; // next step will switch to single
    clearInterval(intervalId);

    intervalId = setInterval(function() {
      if (showTextState) { showPair(); } else { showSingle(); }
      showTextState = !showTextState;
    }, HOLD_MS);

    isMobileRunning = true;
  }

  function stopSliderAndShowAll() {
    clearInterval(intervalId);
    intervalId = null;
    isMobileRunning = false;

    // Ensure all visible and fully opaque on desktop/tablet
    $("#b_top-bar-0, #b_top-bar-1, #b_top-bar-2")
      .stop(true, true).css({display:'block', opacity:1});
  }

  function mobile_top_bar_init() {
    const isMobile = $(window).width() <= MOBILE_MAX;
    if (isMobile && !isMobileRunning) {
      startMobileSlider();
    } else if (!isMobile && isMobileRunning) {
      stopSliderAndShowAll();
    } else if (!isMobile && !isMobileRunning) {
      // First load on desktop
      stopSliderAndShowAll();
    }
  }

  // Run once and then on resize
  mobile_top_bar_init();
  $(window).on('resize', mobile_top_bar_init);
   // ===end of top bar mobile Config====

  
});